<template>
<div>
    <navbar></navbar>
  <section class="section">
    <title-bar>
    Sample Industry Financial Statement -- {{industryname}}
    </title-bar>

    <div class="level">
  <div class="level-item has-text-centered">
    <div>
      <p class="heading">NAICS</p>
      <p class="title">{{naics}}</p>
    </div>
  </div>
  <div class="level-item has-text-centered">
    <div>
      <p class="heading">Geography</p>
      <p class="title">{{geography}}</p>
    </div>
  </div>
  <div class="level-item has-text-centered">
    <div>
      <p class="heading">Sales Size</p>
      <p class="title">{{salesSize}}</p>
    </div>
  </div>
  <div class="level-item has-text-centered">
    <div>
      <p class="heading">Units</p>
      <p class="title">{{dollarUnits}}</p>
    </div>
  </div>
</div>

    <tiles>
    <card-widget class="tile is-child" type="is-primary" icon="domain"  v-bind:number="firms"  label="Firms"/>
    <card-widget class="tile is-child" type="is-primary" icon="square-inc-cash"  v-bind:number="sales" prefix="$" label="Avg. Sales"/>
    <card-widget class="tile is-child" type="is-primary" icon="label-percent"  v-bind:number="growth" suffix="%"  label="Growth(5yr)"/>
    </tiles>
    <tiles>
      <card-widget class="tile is-child" type="is-primary" icon="square-inc-cash"  v-bind:number="grossmargin"  prefix="$"  label="Gross Margin"/>
      <card-widget class="tile is-child" type="is-primary" icon="square-inc-cash"  v-bind:number="profitmargin" prefix="$"   label="Profit Margin"/>
      <card-widget class="tile is-child" type="is-primary" icon="division-box"  v-bind:number="assets2sales" label="Assets / Sales"/>
    </tiles>
    <card-component title="Sales Trend" @header-icon-click="fillChartData" icon="finance" header-icon="reload">
      <div v-if="lineChart.chartData" class="chart-area">
        <line-chart style="height: 100%"
                    ref="bigChart"
                    chart-id="big-line-chart"
                    :chart-data="lineChart.chartData"
                    :extra-options="lineChart.extraOptions">
        </line-chart>
      </div>
    </card-component>

    <card-component title="Benchmark Performance" @header-icon-click="fillBarChartData" icon="finance" header-icon="reload">
      <div v-if="defaultChart.chartData" class="chart-area">
        <bar-chart style="height: 100%"
                    ref="bigBarChart"
                    chart-id="big-bar-chart"
                    :chart-data="defaultChart.chartData"
                    :extra-options="defaultChart.extraOptions">
        </bar-chart>
      </div>
    </card-component>

        <card-component title="Financial Statements & Ratios" class="has-table">
        <p style="color:navy;">Dollar Units: {{dollarUnits}}</p>
          <clients-table-sample data-url="/static/data-sources/clients.json" :checkable="false" v-bind:fsparameters="fsparameters"    />
        </card-component>

  </section>
  </div>
</template>

<script>
// @ is an alias to /src
import Navbar from "./features/Navbar"
import * as chartConfig from './Charts/chart.config'
import CardComponent from './CardComponent'
import Tiles from './Tiles'
import CardWidget from './CardWidget'
import LineChart from './Charts/LineChart'
import BarChart from './Charts/BarChart'
import ClientsTableSample from './ClientsTableSample'
import TitleBar from './TitleBar'
import axios from 'axios'

export default {
  name: 'home',
  components: {
    TitleBar,
    ClientsTableSample,
    CardWidget,
    Tiles,
    CardComponent,
    LineChart,
    BarChart,
    Navbar
  },
  data () {
    return {
    fsparameters: {},
    industryname: "",
    geography: "",
    salesSize:"",
    naics:"",
    dollarUnits:"(thousands)",
    firms: 0,
    sales: 0.0,
    growth: 0.0,
    grossmargin: 0.0,
    profitmargin: 0.0,
    assets2sales: 0.0,
    lineChartData: [],
    barChartData_this: [],
    barChartData_us6: [],
    barChartData_us3: [],
      defaultChart: {
        chartData: null,
        extraOptions: chartConfig.chartOptionsMain
      },
      lineChart: {
        chartData: null,
        extraOptions: chartConfig.chartOptionsMain
      }
    }
  },
  computed: {

  },
  mounted () {
  this.getNumbers()
  //this.fillChartData()
  this.fillBarChartData()

  },
  methods: {
    getNumbers() {
    
            var URI = this.$api.REST_API + '/Reports/Norm' 
    axios
      .post(URI, {naics: "213000", range: "10", state: "", zip: "" })
      .then(r => {
      console.log(r)
      this.dollarUnits = r.data.units.charAt(0).toUpperCase() +  r.data.units.substr(1).toLowerCase()
      this.naics = r.data.naics
      this.salesSize = "$100M-$250M"
      this.geography = "National"
      this.industryname = r.data.naicsdescription
      this.firms = r.data.firms
      this.sales = r.data.sales.toFixed(1)
      this.growth = (r.data.growth5-1)*100.00
      this.growth = this.growth.toFixed(2)
      this.grossmargin = r.data.income.gm.toFixed(1)
      this.profitmargin = (r.data.income.profitx + 0.01).toFixed(2)
      this.assets2sales = r.data.balance.totasset/this.sales
      this.assets2sales = this.assets2sales.toFixed(2)
//      this.$set(this.fsparameters, 'balance',r.data.balance)
//      this.$set(this.fsparameters, 'income',r.data.income)
//      this.$set(this.fsparameters, 'sales',this.sales)

console.log(r.data.saleshistory)
// console.log(r.data.saleshistory)

        let sh = r.data.saleshistory
        console.log(sh)
        this.lineChartData.push(sh.yr2015)
        this.lineChartData.push(sh.yr2016)
        this.lineChartData.push(sh.yr2017)
        this.lineChartData.push(sh.yr2018)
        this.lineChartData.push(sh.yr2019)
        this.lineChartData.push(sh.yr2020)

      this.fillChartData()

      let bn = r.data.benchmarksnormalized
      let bn_this = bn.benchmarkthis
      let bn_us6 = bn.benchmarkus6
      let bn_us3 = bn.benchmarkus3

      this.barChartData_this.push(bn_this.sales2emps)
      this.barChartData_this.push(bn_this.profit2emps)
      this.barChartData_this.push(bn_this.cgs2sales)
  //    this.barChartData_this.push(bn_this.inventoryturns)
      this.barChartData_this.push(bn_this.ap2sales)
      this.barChartData_this.push(bn_this.quickratio)
      this.barChartData_this.push(bn_this.currentratio)
      this.barChartData_this.push(bn_this.profitmargin)

      this.barChartData_us6.push(bn_us6.sales2emps)
      this.barChartData_us6.push(bn_us6.profit2emps)
      this.barChartData_us6.push(bn_us6.cgs2sales)
//      this.barChartData_us6.push(bn_us6.inventoryturns)
      this.barChartData_us6.push(bn_us6.ap2sales)
      this.barChartData_us6.push(bn_us6.quickratio)
      this.barChartData_us6.push(bn_us6.currentratio)
      this.barChartData_us6.push(bn_us6.profitmargin)

      this.barChartData_us3.push(bn_us3.sales2emps)
      this.barChartData_us3.push(bn_us3.profit2emps)
      this.barChartData_us3.push(bn_us3.cgs2sales)
//      this.barChartData_us3.push(bn_us3.inventoryturns)
      this.barChartData_us3.push(bn_us3.ap2sales)
      this.barChartData_us3.push(bn_us3.quickratio)
      this.barChartData_us3.push(bn_us3.currentratio)
      this.barChartData_us3.push(bn_us3.profitmargin)

      this.fillBarChartData()

      })
      .catch(e => {
      })
    },
    randomChartData (n) {
      let data = []

      for (let i = 0; i < n; i++) {
        data.push(Math.round(Math.random() * 200))
      }

      return data
    },
    fillBarChartData () {
      this.defaultChart.chartData = {
        datasets: [
          {
          label: 'Your NAICS',
          borderColor: '65AFFF',
          backgroundColor: '65AFFF',
          borderWidth: 2,
          data: this.barChartData_this
          },
          {
          label: 'US 3-digit NAICS',
          borderColor: '#335C81',
          backgroundColor: '#335C81',
          data: this.barChartData_us3

          },
          {
          label: 'US 6-digit NAICS',
          borderColor: '#274060',
          backgroundColor: '#274060',
          data: this.barChartData_us6
          }
        ],
        labels: ['Sales/Emps', 'Op Profit/Emps', 'CGS/Sales',  'AP/Sales', 'Quick Ratio', 'Current Ratio', 'Profit Margin']
      }
    },
    fillChartData () {
      this.lineChart.chartData = {
        datasets: [
          {
          label: 'Annual Sales',
            fill: false,
            borderColor: chartConfig.chartColors.default.info,
            borderWidth: 2,
            borderDash: [],
            borderDashOffset: 0.0,
            lineTension: 0,
            pointBackgroundColor: 'green',
            pointBorderColor: 'rgba(255,255,255,0)',
            pointHoverBackgroundColor: chartConfig.chartColors.default.info,
            pointBorderWidth: 20,
            pointHoverRadius: 4,
            pointHoverBorderWidth: 15,
            pointRadius: 4,
            data: this.lineChartData
          }
        ],
        labels: ['2015', '2016','2017','2018','2019','2020' ]
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/SampleReports.vue